import { Pago } from "./pago";
import { Compra } from "./compra";

export class PagoGrupo{
    public constructor(
        public id: String = "",
        public pago_id: String = "",
        public compra_id: String = "",
        
        //public caja_id: String = "",

        public usuario_id:String = null,
        public pago: Pago = new Pago(),
       // public compra: Compra = new Compra(),
    ){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/pago-grupo.ts